/** MaxAutoParts (maxautoparts.online) — single source for phone on all pages */
export const PHONE = '1-833-597-6924';
export const PHONE_RAW = '+18335976924';

export const CONTACT = {
  phone: PHONE,
  phoneTel: PHONE_RAW,
  email: 'support@maxautoparts.online',
  website: 'maxautoparts.online',
  websiteUrl: 'https://www.maxautoparts.online',
  hoursWeekdays: 'Mon–Fri: 8AM–8PM EST',
  hoursSaturday: 'Sat: 9AM–5PM EST',
};

export const phoneHref = `tel:${CONTACT.phoneTel}`;
